import { processPath } from "@/services/backend/processes/lib/process-path";
import { ComponentProps } from "react";
import type { VariantProps } from "class-variance-authority";
import { Button, buttonVariants } from "@/shared/components/ui/button";
import { NavLink } from "react-router";
import { cn } from "@/shared/lib/utils";
import { ServiceKind } from "@bitory-gmbh/bsm";

export function ProcessLinkButton({
  children,
  serviceKind,
  processId,
  className,
  ...props
}: ComponentProps<"button"> &
  VariantProps<typeof buttonVariants> & {
    serviceKind: ServiceKind | null;
    processId: string;
  }) {
  return (
    <Button asChild className={cn("whitespace-normal", className)} {...props}>
      <NavLink to={processPath(serviceKind, processId)}>{children}</NavLink>
    </Button>
  );
}
